var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 146,
    viewBox: "0 0 227 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M186.872 143.994L189.45 138.788M178 132.928L183.7 131.683M181.172 119.134L185.704 122.787M194.008 113L193.957 118.798M206.838 119.143L202.242 122.721M210 132.94L204.322 131.601M201.115 144L198.628 138.754",
    stroke: "#F1D653",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M214.436 112.997L215.725 110.478M210 107.642L212.85 107.04M211.586 100.968L213.852 102.735M218.004 98L217.979 100.805M224.419 100.972L222.121 102.704M226 107.648L223.161 107.001M221.558 113L220.314 110.462",
    stroke: "#F2B96B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8920_7229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.4684 32.429L40.475 34.8923L37.9852 39.8327L35.4954 34.8923L30.502 32.429L35.4954 29.9657L37.9852 25.0254L40.475 29.9657L45.4684 32.429Z",
    fill: "#DC6803"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2539 32.4301C11.2539 31.1668 12.2889 30.1445 13.564 30.1445H22.2169C23.4938 30.1445 24.527 31.1685 24.527 32.4301C24.527 33.6916 23.4921 34.7156 22.2169 34.7156H13.5657C12.2889 34.7156 11.2556 33.6916 11.2556 32.4301H11.2539Z",
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3242 32.4301C52.3242 31.1668 53.3592 30.1445 54.6343 30.1445H63.2873C64.5641 30.1445 65.5974 31.1685 65.5974 32.4301C65.5974 33.6916 64.5624 34.7156 63.2873 34.7156H54.6343C53.3575 34.7156 52.3242 33.6916 52.3242 32.4301Z",
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5936 16.6712C22.2743 15.9976 23.3784 15.9976 24.0592 16.6712L27.4647 19.8866C28.1455 20.5602 28.1455 21.6525 27.4647 22.326C26.784 22.9996 25.6799 22.9996 24.9991 22.326L21.5936 19.1105C20.9128 18.437 20.9128 17.3447 21.5936 16.6712Z",
    fill: "#F5E287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2149 16.755C54.8507 17.3841 54.8507 18.4029 54.2149 19.032L51.0098 22.109C50.3739 22.7381 49.3442 22.7381 48.7083 22.109C48.0725 21.4799 48.0725 20.4611 48.7083 19.832L51.9134 16.755C52.5493 16.1259 53.5791 16.1259 54.2149 16.755Z",
    fill: "#F5E287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9836 18.6858C36.9711 18.6858 36.1504 17.8739 36.1504 16.8721V7.81373C36.1504 6.81199 36.9711 6 37.9836 6C38.9961 6 39.8168 6.81199 39.8168 7.81373V16.8704C39.8168 17.8721 38.9961 18.6841 37.9836 18.6841V18.6858Z",
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9834 64.0007C36.8707 64.0007 35.9688 63.1083 35.9688 62.0074V49.337C35.9688 48.2361 36.8707 47.3438 37.9834 47.3438C39.0961 47.3438 39.998 48.2361 39.998 49.337V62.0074C39.998 63.1083 39.0961 64.0007 37.9834 64.0007Z",
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6367 49.0245C52.1797 49.0245 53.4306 47.7869 53.4306 46.2603C53.4306 44.7337 52.1797 43.4961 50.6367 43.4961C49.0936 43.4961 47.8428 44.7337 47.8428 46.2603C47.8428 47.7869 49.0936 49.0245 50.6367 49.0245Z",
    fill: "#F5E287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8997 42.3888C27.6237 43.105 27.6237 44.2674 26.8997 44.9837L23.2488 48.4898C22.5249 49.2061 21.3499 49.2061 20.626 48.4898C19.902 47.7735 19.902 46.6111 20.626 45.8948L24.2769 42.3888C25.0008 41.6725 26.1757 41.6725 26.8997 42.3888Z",
    fill: "#F5E287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0661 17.4816L12.8056 19.5381C12.8367 19.627 12.9006 19.6954 12.9783 19.7313L14.8254 20.5552C15.0863 20.6715 15.0863 21.0834 14.8254 21.1997L12.9783 22.0236C12.8989 22.0595 12.8367 22.1279 12.8056 22.2168L12.0661 24.2733C11.9624 24.5639 11.5926 24.5639 11.4872 24.2733L10.7477 22.2168C10.7166 22.1279 10.6527 22.0595 10.5749 22.0236L8.7279 21.1997C8.467 21.0834 8.467 20.6715 8.7279 20.5552L10.5749 19.7313C10.6544 19.6954 10.7166 19.627 10.7477 19.5381L11.4872 17.4816C11.5909 17.191 11.9607 17.191 12.0661 17.4816Z",
    fill: "#DC6803"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2555 43.7961L64.995 45.8526C65.0261 45.9414 65.0901 46.0098 65.1678 46.0457L67.0148 46.8697C67.2757 46.9859 67.2757 47.3979 67.0148 47.5141L65.1678 48.3381C65.0883 48.374 65.0261 48.4424 64.995 48.5313L64.2555 50.5877C64.1518 50.8783 63.7821 50.8783 63.6767 50.5877L62.9372 48.5313C62.9061 48.4424 62.8422 48.374 62.7644 48.3381L60.9174 47.5141C60.6565 47.3979 60.6565 46.9859 60.9174 46.8697L62.7644 46.0457C62.8439 46.0098 62.9061 45.9414 62.9372 45.8526L63.6767 43.7961C63.7804 43.5055 64.1501 43.5055 64.2555 43.7961Z",
    fill: "#DC6803"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46 124C46 119.582 42.4183 116 38 116V116C33.5817 116 30 119.582 30 124V124C30 128.418 33.5817 132 38 132V132C42.4183 132 46 128.418 46 124V124Z",
    stroke: "#F5E287",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M178 58C178 54.6863 180.686 52 184 52V52C187.314 52 190 54.6863 190 58V58C190 61.3137 187.314 64 184 64V64C180.686 64 178 61.3137 178 58V58Z",
    stroke: "#EECD30",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M137.99 59.3884L128.025 69.3495L119.081 58.5043C115.935 54.6887 110.062 54.6887 106.915 58.5043L97.9718 69.3495L88.0063 59.3884C86.1434 57.5264 82.9453 58.8374 82.9453 61.4632V86.0715L143.051 86.0715V61.4632C143.051 58.8373 139.853 57.5262 137.99 59.3884Z",
    fill: "url(#paint0_linear_8920_7229)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M133.223 64.9486L130.149 60.2535C128.269 57.3802 124.035 57.3802 122.154 60.2535L119.081 64.9486C116.218 69.3231 109.773 69.3231 106.909 64.9486L103.836 60.2535C101.955 57.3802 97.7219 57.3802 95.8412 60.2535L92.768 64.9486C89.9046 69.3231 83.4595 69.3231 80.5961 64.9486L74.734 55.9928C73.3985 53.9524 70.2139 55.3021 70.7707 57.6724L79.9689 96.8143L146.022 96.8143L155.22 57.6724C155.777 55.3022 152.592 53.9526 151.257 55.9928L145.394 64.9486C142.531 69.3231 136.086 69.3231 133.223 64.9486Z",
    fill: "url(#paint1_linear_8920_7229)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0404 85.2803C97.5481 85.2803 99.5809 83.2601 99.5809 80.7681C99.5809 78.2761 97.5481 76.2559 95.0404 76.2559C92.5328 76.2559 90.5 78.2761 90.5 80.7681C90.5 83.2601 92.5328 85.2803 95.0404 85.2803Z",
    fill: "url(#paint2_linear_8920_7229)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8573 78.9609L93.2197 82.576L103.508 92.8001H110.783L96.8573 78.9609Z",
    fill: "url(#paint3_linear_8920_7229)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0419 83.3273C96.4625 83.3273 97.6141 82.1828 97.6141 80.7711C97.6141 79.3593 96.4625 78.2148 95.0419 78.2148C93.6213 78.2148 92.4697 79.3593 92.4697 80.7711C92.4697 82.1828 93.6213 83.3273 95.0419 83.3273Z",
    fill: "url(#paint4_linear_8920_7229)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M131.448 85.2803C133.955 85.2803 135.988 83.2601 135.988 80.7681C135.988 78.2761 133.955 76.2559 131.448 76.2559C128.94 76.2559 126.907 78.2761 126.907 80.7681C126.907 83.2601 128.94 85.2803 131.448 85.2803Z",
    fill: "url(#paint5_linear_8920_7229)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M140.113 85.7698L133.264 78.9629L129.626 82.578L138.736 91.6312L140.113 85.7698Z",
    fill: "url(#paint6_linear_8920_7229)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M131.447 83.3273C132.868 83.3273 134.019 82.1828 134.019 80.7711C134.019 79.3593 132.868 78.2148 131.447 78.2148C130.027 78.2148 128.875 79.3593 128.875 80.7711C128.875 82.1828 130.027 83.3273 131.447 83.3273Z",
    fill: "url(#paint7_linear_8920_7229)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M113.24 90.5828C116.655 90.5828 119.424 86.6467 119.424 81.7914C119.424 76.936 116.655 73 113.24 73C109.825 73 107.057 76.936 107.057 81.7914C107.057 86.6467 109.825 90.5828 113.24 90.5828Z",
    fill: "url(#paint8_linear_8920_7229)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M115.94 76.4336L110.699 87.3029L116.229 92.7985H132.408L115.94 76.4336Z",
    fill: "url(#paint9_linear_8920_7229)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M113.24 88.3826C115.8 88.3826 117.876 85.4314 117.876 81.7909C117.876 78.1504 115.8 75.1992 113.24 75.1992C110.679 75.1992 108.604 78.1504 108.604 81.7909C108.604 85.4314 110.679 88.3826 113.24 88.3826Z",
    fill: "url(#paint10_linear_8920_7229)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M144.819 104.263C123.733 107.4 102.256 107.236 81.2234 103.777C80.7729 103.703 80.3311 103.716 79.9134 103.801C77.3586 104.326 77.4148 108.032 79.9794 108.507C79.9968 108.51 80.0144 108.513 80.032 108.516C101.805 112.219 124.072 112.387 145.902 109.011C145.915 109.009 145.928 109.007 145.942 109.005C148.588 108.565 148.593 104.718 145.949 104.273C145.586 104.212 145.206 104.206 144.819 104.263Z",
    fill: "url(#paint11_linear_8920_7229)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2656 81.0586L79.968 96.8135L146.021 96.8135L149.723 81.0586L76.2656 81.0586Z",
    fill: "url(#paint12_linear_8920_7229)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0576 97.064V100.454C77.0576 102.19 78.3139 103.677 80.0351 103.97C101.808 107.673 124.075 107.841 145.905 104.465C147.65 104.195 148.935 102.696 148.935 100.941V97.5588C148.935 95.3815 146.988 93.7105 144.822 94.0327C123.737 97.1693 102.259 97.0052 81.2265 93.5467C79.0426 93.1875 77.0576 94.8641 77.0576 97.064Z",
    fill: "url(#paint13_linear_8920_7229)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1116 102.607L80.8787 100.388C80.2891 99.8019 80.2891 98.8518 80.8787 98.2659L83.1116 96.0468C83.7011 95.4609 84.6572 95.4609 85.2468 96.0468L87.4796 98.2659C88.0692 98.8518 88.0692 99.8019 87.4796 100.388L85.2468 102.607C84.6572 103.193 83.7013 103.193 83.1116 102.607Z",
    fill: "url(#paint14_linear_8920_7229)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6379 104.042L92.4051 101.823C91.8155 101.237 91.8155 100.287 92.4051 99.7014L94.6379 97.4824C95.2275 96.8965 96.1836 96.8965 96.7731 97.4824L99.006 99.7014C99.5956 100.287 99.5956 101.237 99.006 101.823L96.7731 104.042C96.1836 104.628 95.2277 104.628 94.6379 104.042Z",
    fill: "url(#paint15_linear_8920_7229)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M106.168 105.036L103.935 102.817C103.346 102.232 103.346 101.281 103.935 100.696L106.168 98.4765C106.758 97.8906 107.714 97.8906 108.303 98.4765L110.536 100.696C111.126 101.281 111.126 102.232 110.536 102.817L108.303 105.036C107.714 105.622 106.758 105.622 106.168 105.036Z",
    fill: "url(#paint16_linear_8920_7229)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M117.686 105.035L115.453 102.816C114.863 102.23 114.863 101.279 115.453 100.694L117.686 98.4746C118.275 97.8887 119.231 97.8887 119.821 98.4746L122.054 100.694C122.643 101.279 122.643 102.23 122.054 102.816L119.821 105.035C119.231 105.62 118.276 105.62 117.686 105.035Z",
    fill: "url(#paint17_linear_8920_7229)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M129.214 104.042L126.981 101.823C126.392 101.237 126.392 100.287 126.981 99.7014L129.214 97.4824C129.804 96.8965 130.76 96.8965 131.349 97.4824L133.582 99.7014C134.172 100.287 134.172 101.237 133.582 101.823L131.349 104.042C130.76 104.628 129.804 104.628 129.214 104.042Z",
    fill: "url(#paint18_linear_8920_7229)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M140.742 102.609L138.51 100.39C137.92 99.8038 137.92 98.8537 138.51 98.2678L140.742 96.0488C141.332 95.4629 142.288 95.4629 142.878 96.0488L145.11 98.2678C145.7 98.8537 145.7 99.8038 145.11 100.39L142.878 102.609C142.288 103.195 141.332 103.195 140.742 102.609Z",
    fill: "url(#paint19_linear_8920_7229)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8920_7229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.502 122.733C121.64 122.733 128.237 116.136 128.237 107.999C128.237 99.8607 121.64 93.2637 113.502 93.2637C105.365 93.2637 98.7676 99.8607 98.7676 107.999C98.7676 116.136 105.365 122.733 113.502 122.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.502 122.733C121.64 122.733 128.237 116.136 128.237 107.999C128.237 99.8607 121.64 93.2637 113.502 93.2637C105.365 93.2637 98.7676 99.8607 98.7676 107.999C98.7676 116.136 105.365 122.733 113.502 122.733Z",
    fill: "url(#paint20_linear_8920_7229)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.502 122.733C121.64 122.733 128.237 116.136 128.237 107.999C128.237 99.8607 121.64 93.2637 113.502 93.2637C105.365 93.2637 98.7676 99.8607 98.7676 107.999C98.7676 116.136 105.365 122.733 113.502 122.733Z",
    stroke: "#DC6803",
    strokeWidth: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.502 122.733C121.64 122.733 128.237 116.136 128.237 107.999C128.237 99.8607 121.64 93.2637 113.502 93.2637C105.365 93.2637 98.7676 99.8607 98.7676 107.999C98.7676 116.136 105.365 122.733 113.502 122.733Z",
    stroke: "url(#paint21_linear_8920_7229)",
    strokeWidth: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.546 105.227L112.679 113.185C112.006 113.855 110.91 113.855 110.238 113.185L109.933 112.881L109.02 111.964L106.456 109.435C105.787 108.765 105.787 107.666 106.456 106.996C107.129 106.323 108.225 106.323 108.898 106.996L111.458 109.526L118.104 102.819C118.777 102.146 119.873 102.146 120.546 102.819C121.216 103.458 121.216 104.554 120.546 105.227Z",
    fill: "#DC6803"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8920_7229",
    x1: 112.998,
    y1: 55.9862,
    x2: 112.998,
    y2: 69.0906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA613"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8920_7229",
    x1: 112.997,
    y1: 64.8703,
    x2: 113.004,
    y2: 100.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA613"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8920_7229",
    x1: 98.7313,
    y1: 84.4361,
    x2: 92.1163,
    y2: 77.7796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA613"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8920_7229",
    x1: 103.786,
    y1: 89.4618,
    x2: 90.7547,
    y2: 76.3489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA613",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8920_7229",
    x1: 94.1735,
    y1: 79.908,
    x2: 96.6938,
    y2: 82.4441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3DAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26A6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8920_7229",
    x1: 135.139,
    y1: 84.4361,
    x2: 128.524,
    y2: 77.7796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA613"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8920_7229",
    x1: 137.167,
    y1: 86.4574,
    x2: 128.642,
    y2: 77.8794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA613",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8920_7229",
    x1: 130.579,
    y1: 79.908,
    x2: 133.099,
    y2: 82.4441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3DAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26A6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_8920_7229",
    x1: 119.446,
    y1: 81.7914,
    x2: 108.293,
    y2: 81.7914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA613"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_8920_7229",
    x1: 125.505,
    y1: 91.8434,
    x2: 108.361,
    y2: 78.5246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA613",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_8920_7229",
    x1: 110.649,
    y1: 79.2158,
    x2: 114.807,
    y2: 83.3999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4755"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA2E43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_8920_7229",
    x1: 112.978,
    y1: 105.542,
    x2: 112.979,
    y2: 112.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA613"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_8920_7229",
    x1: 112.994,
    y1: 87.7428,
    x2: 112.994,
    y2: 99.5014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA613",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_8920_7229",
    x1: 112.996,
    y1: 96.6543,
    x2: 112.998,
    y2: 107.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA613"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_8920_7229",
    x1: 87.6997,
    y1: 102.825,
    x2: 82.0264,
    y2: 97.1167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA613"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_8920_7229",
    x1: 99.2261,
    y1: 104.261,
    x2: 93.5528,
    y2: 98.5523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA613"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_8920_7229",
    x1: 110.756,
    y1: 105.255,
    x2: 105.083,
    y2: 99.5462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA613"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_8920_7229",
    x1: 122.274,
    y1: 105.253,
    x2: 116.601,
    y2: 99.5443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA613"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_8920_7229",
    x1: 133.802,
    y1: 104.261,
    x2: 128.129,
    y2: 98.5523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA613"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_8920_7229",
    x1: 145.331,
    y1: 102.827,
    x2: 139.657,
    y2: 97.1187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA613"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_8920_7229",
    x1: 113.503,
    y1: 130.631,
    x2: 113.503,
    y2: 94.2065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF3B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_8920_7229",
    x1: 113.315,
    y1: 143.206,
    x2: 113.315,
    y2: 70.1834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.215225,
    stopColor: "#FFE257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688835,
    stopColor: "#C57505"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8920_7229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 58,
    fill: "white",
    transform: "translate(8.5 6)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8920_7229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(96.5 91)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSuccess);
export default __webpack_public_path__ + "static/media/ico-success.1d32fe39bfb1b11190ce30d2de66c67a.svg";
export { ForwardRef as ReactComponent };